import React from "react";

import Table from "components/Table";


const RulesTable = ({
    data,
    ...props
}) => {

    const columns = [
        {
            flexGrow: 2,
            id: "senderid",
            label: "Sender",
            dataKey: "senderid",
        },
        {
            flexGrow: 2,
            id: "sender_name",
            label: "Origin",
            value: (({ sender_name }) => sender_name || "—"),
            dataKey: "sender_name",
        },
        {
            flexGrow: 2,
            id: "phone",
            label: "Phone",
            dataKey: "phone",
        },
        {
            flexGrow: 4,
            id: "message",
            label: "Message",
            dataKey: "message",
            placeholder: "Message",
        },
        {
            flexGrow: 1,
            id: "cnt",
            align: "center",
            label: "Count",
            dataKey: "cnt",
            placeholder: "Count"
        }
    ];

    return (
        <Table
            virtualized
            data={data}
            extraHeight={500}
            columns={columns}
            headerHeight={40}
            autoHeight={false}
            errorPlacement={"bottom"}
            {...props}
        />
    );
};

export default RulesTable;